import React from 'react';

const Footer = () => {
  return (
    <>
      {/* Inline CSS with media queries */}
      <style>{`
        .footer {
          margin: 0 auto;
          margin-top: -30px;
          background: linear-gradient(135deg, #023e8a, #0077b6);
          color: #fff;
          text-align: center;
          padding: 16px 20px;
          border-top-left-radius: 12px;
          border-top-right-radius: 12px;
          box-shadow: 0 -2px 8px rgba(0,0,0,0.1);
          font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
          width: 100%;
          max-width: 100%;   /* default for small screens */
        }

        /* Laptop screens: 1280–1439px */
        @media (min-width: 1280px) and (max-width: 1439.98px) {
          .footer {
            max-width: 1310px;
          }
        }

        /* Desktop screens: ≥1440px */
        @media (min-width: 1440px) {
          .footer {
            max-width: 1420px;
          }
        }

        .footer a {
          color: #fff;
          text-decoration: none;
        }

        .footer p {
          font-size: 14px;
          letter-spacing: 0.3px;
        }
      `}</style>

      <footer className="footer">
        <p>
          <a
            href="https://www.typco.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Thomas Y. Pickett
          </a>{' '}
          — © 2025
        </p>
      </footer>
    </>
  );
};

export default Footer;

